const sdkVersion = (): number => {
  const ua = navigator.userAgent.toLowerCase();
  // eslint-disable-next-line no-useless-escape
  const jssdk = /(jssdk)[ \/]([\w.]+)/;
  const match = jssdk.exec(ua);
  let version;
  if (match === null) {
    version = '0';
    return parseFloat(version);
  } else {
    version = match[2] || '0.1';
    return parseFloat(version);
  }
};

export default sdkVersion;
